(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["help-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initAccordions() {
    var items = Array.prototype.slice.call(
      document.querySelectorAll('.hp__content details')
    );
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) {
          items.forEach(function (o) {
            if (o !== d && o.open) o.open = false;
          });
        }
      });
    });
  }
  if (document.readyState !== 'loading') initAccordions();
  else document.addEventListener('DOMContentLoaded', initAccordions);
})();

  } catch(e) { console.error(e); }
})();
})();
